import { render, staticRenderFns } from "./softPromote.vue?vue&type=template&id=5029fb14&scoped=true&"
import script from "./softPromote.vue?vue&type=script&lang=js&"
export * from "./softPromote.vue?vue&type=script&lang=js&"
import style0 from "./softPromote.vue?vue&type=style&index=0&id=5029fb14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029fb14",
  null
  
)

export default component.exports